// The dance directory (/dances): the server lays out every dance as a card
// (plazmi.dance-page/directory-html); this draws each score with its
// pictograms and opens a card in place into a small stage with an anonymous
// plazmi dancing it, one at a time (dance.ts, loaded only when asked).
import { scoreHtml, SCORE_CSS } from './score.js';

const st = document.createElement('style');
st.textContent = SCORE_CSS + `.dcard .dance-stage{margin-top:8px}`;
document.head.appendChild(st);

for (const card of document.querySelectorAll<HTMLElement>('.dance-card[data-beats]')) {
  try {
    const sc = card.querySelector('.score');
    if (sc) sc.outerHTML = scoreHtml(JSON.parse(card.dataset.beats || '[]'));
  } catch (e) { console.error(e); }
}

const demoUrl = '/js/dance.js';
async function toggle(card: HTMLElement) {
  const m = await import(/* @vite-ignore */ demoUrl);
  await m.openInline(card);
}

document.addEventListener('click', (e) => {
  const t = e.target as HTMLElement;
  if (t.closest('.dance-stage') || t.closest('a')) return;
  const card = t.closest('.dance-card[data-dance]') as HTMLElement | null;
  if (card) { e.preventDefault(); toggle(card).catch((err) => console.error(err)); }
});
document.addEventListener('keydown', (e) => {
  const t = e.target as HTMLElement;
  if ((e.key === 'Enter' || e.key === ' ') && t.matches?.('.dance-card[data-dance]')) { e.preventDefault(); toggle(t).catch((err) => console.error(err)); }
});
(window as any).__ready = true;
